import styled, { css } from 'styled-components';

export const Body = styled.div`
width: 100%;
background-color: #FFFF;
overflow-x: hidden;
height: 100%;
display: flex;
`
export const ImageContainber = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const SchoolImage = styled.img`
width: 100%;
height: 100%; 
position: relative;
border-top-right-radius:5%;
border-bottom-right-radius:5%;
`

export const LogoImage = styled.img`
position: absolute;
top:32px;
left: 53px;
z-index: 5;
width: 10%;
background-color: #ffff;
`
export const Content = styled.div`
position: absolute;
top: 170px;
left: 4%;
width:fit-content;
line-break: auto;
`
export const Title = styled.h1`
font-style: normal;
font-weight: var(--general-display-font-weight);
font-size: var(--general-display-font-size);
line-height: 39px;
color: var(--font-color-white);

`
export const Description = styled.p`
width: 660.18px;
font-family: var(--general-large-body-font-family);
font-style: normal;
font-weight: var(--general-large-body-font-weight);
font-size: var(--general-large-body-font-size);
line-height: 26px;
text-transform: capitalize;
color: var(--font-color-white);
max-width: 80%;
`
export const AboutUs = styled.button`
background-color: #FFFFFF;
color: var(--font-color-blue2555ef);
border:none;
padding:5px;
padding-left: 10px;
padding-right: 10px;
font-weight: var(--general-label-font-weight);
font-size: var(--general-label-font-size);
`
export const RightSide = styled.div`
   @media only screen and (max-width: 1920px) and (max-height: 1080px) {
    margin: 31px 40px ;
    margin-left:61px ;
    width:40%;
  }
  width:45%;
  margin-top: 77px;
`
export const LeftSide = styled.div`
  flex: 1;
  width: 60%;
  margin-right:30px;

`

export const Spinner = styled.div`
width: 100%;
height: 100%;
display: flex;
justify-content: center;
align-items: center;
`